import React from 'react';
import PropTypes from 'prop-types';

function Tick({ fill, className }) {
  return (
    <svg
      className={className}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 130.2 130.2"
    >
      <circle
        className="path circle"
        fill={fill}
        stroke="none"
        strokeWidth="6"
        strokeMiterlimit="10"
        cx="65.1"
        cy="65.1"
        r="62.1"
      />
      <polyline
        className="path check"
        fill="none"
        stroke="#FFF"
        strokeWidth="6"
        strokeLinecap="round"
        strokeMiterlimit="10"
        points="100.2,40.2 51.5,88.8 29.8,67.5 "
      />
    </svg>
  );
}

Tick.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
};

Tick.defaultProps = {
  fill: '#40a499',
  className: '',
};

export default Tick;
